export const AOI_STATUS_STRINGS = {
  success: 'success',
  partialSuccess: 'partial_success',
  failed: 'failed',
  started: 'started'
};

export const ASSET_STATUS_STRINGS = {
  success: 'success',
  started: ['started', 'creating'],
  failed: 'failed'
};

export const ASSET_TYPE_STRINGS = {
  mosaic: 'mosaic',
  tile: 'tile',
  layer: 'layer', // deprecated
  visualization: 'visualization',
  stac_item: 'stac_item'
};
export const ATLAS_DATA_CUBE = 'datacube';

export const ALLOWED_ASSET_TYPES = [
  ASSET_TYPE_STRINGS.mosaic,
  ASSET_TYPE_STRINGS.stac_item
];

export const EXCLUDE_ASSET_NAMES = ['latest_data.tiff', ATLAS_DATA_CUBE];

export const WILDCARD_BAND_ASSET_NAMES = ['SCL'];

export const VISUALIZATION_EXPRESSION_TYPES = {
  customIndex: 'index',
  singleBand: 'grayscale',
  RGBComposite: 'composite'
};

export const COMPATIBLE_VIZ_CHANGE_DETECTION = [
  VISUALIZATION_EXPRESSION_TYPES.customIndex,
  VISUALIZATION_EXPRESSION_TYPES.singleBand
];
